import React, { Component } from 'react';
import {
  Route as ReactRoute,
  RouteProps
} from 'react-router-dom';
import * as _ from 'lodash';
import { ROUTE } from './Types';

export const ROUTE_PREFIX: string = 'tp-route-';

class Route extends Component<ROUTE, {}> {
  constructor(props: ROUTE) {
    super(props);
    // <debug>
    if (!props.routeKey) {
      throw new Error('Parameter `routeKey` missing! Please provide unique `routeKey` for every route!');
    }
    if (_.isFunction(props.render) && props.component) {
      throw new Error('Configuration conflict! Please provide `render` method or `component` that will be rendered!');
    }
    // </debug>
  }

  render() {
    let { component } = this.props;
    const {
      exact,
      path,
      render,
      routeKey,
      sensitive,
      strict,
      text = '',
      location
    } = this.props;

    let routeConfig: any = {
      exact,
      path,
      sensitive,
      strict,
      location
    };

    if (_.isFunction(render)) {
      routeConfig.render = render;
    } else if (component) {
      routeConfig.render = (routeProps: RouteProps) => {
        let renderComponent: any;
        if (component.type === undefined && _.isFunction(component)) {
          component = component();
        }
        renderComponent = (
          <component.type
            {...component.props}
            {...routeProps}
            title={text}
          />
        );
        return renderComponent;
      };
    }

    return (
      <ReactRoute
        key={`${ROUTE_PREFIX}${routeKey}`}
        {...routeConfig}
      />
    );
  }
}

export default Route;
